import { mountUserMenu } from 'frontend/unpoly/javascripts/user_menu/component'
import type { UserMenuData } from 'frontend/unpoly/javascripts/user_menu/types'

up.compiler('[data-user-menu]', (element, data: UserMenuData) => mountUserMenu(element, data))
